import React from 'react'
import { ReactElement } from 'react'

import Field, {
  FieldPrefix,
  Label,
  useField,
} from '../../../../../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import ReadonlyInput from '../../../../../../../../../1stlog-ui/src/components/Input/ReadonlyInput'
import ReusableBoxInfo from '../../../../../../components/ReusableBoxInfo'
import ReusableBoxSearch from './ReusableBoxSearch'

type TReusableBoxOptionProps = {
  readonly: boolean
}

const ReusableBoxOption = (props: TReusableBoxOptionProps): ReactElement => {
  const { readonly } = props

  const identifier = useFieldValue<string>('value.identifier')
  const data = useField('value.data')
  const validateType = (value: string): string | undefined => {
    if (!value) {
      return i18n.t('enter_valid_rbx', 'Bitte gültige Mehrwegbox angeben')
    }
  }

  // reusablebox barcode reusablebox identifier MX-P64JX-123
  return (
    <div className="mt-1">
      {readonly ? (
        <div>
          <Label>{i18n.t('reusable_box_identifier', 'Bezeichnung')}</Label>
          <div>{identifier}</div>
        </div>
      ) : (
        <FieldPrefix prefix="value">
          <ReusableBoxSearch />
        </FieldPrefix>
      )}
      <Field name="value.data.type" label="" validate={validateType}>
        <ReadonlyInput hideValue />
      </Field>
      <ReusableBoxInfo data={data} />
    </div>
  )
}

export default ReusableBoxOption
